import {useState} from "react";
import PropTypes from "prop-types";

import {HEALTH_ADJECTIVE_CHOICES, HEALTH_VALUES, HEALTH_VALUES_FOR_SMOKERS} from "shared/constants/health";
import {SMOKER} from "shared/constants/smoking";

import healthIcon from 'apps/QuoterApp/assets/images/Heart Icon.svg';
import healthIconSelected from 'apps/QuoterApp/assets/images/Heart Icon - Selected.svg';

import 'apps/QuoterApp/pages/BasicInformationPage/HealthPicker/styles.scss';

function HealthPicker({value: propsValue, smoking, onChange}) {
    const [hoverValue, setHoverValue] = useState();

    const value = hoverValue || propsValue;

    // Smokers have different health values
    const healthValues = (smoking === SMOKER ? HEALTH_VALUES_FOR_SMOKERS : HEALTH_VALUES).slice().sort();
    const options = healthValues.map((itemValue) => (
        <img
            key={itemValue}
            className={"HealthPicker__Icons__Icon"}
            src={value && value >= itemValue ? healthIconSelected : healthIcon}
            alt={'Heart'}
            tabIndex={0}
            role={"button"}
            onClick={() => onChange(itemValue)}
            onMouseOver={() => setHoverValue(itemValue)}
            onMouseLeave={() => setHoverValue(undefined)}
        />
    ));

    return <div className={"HealthPicker"}>
        <div className={"HealthPicker__Icons"}>
            {options}
        </div>
        <div className={"HealthPicker__Text"}>
            &nbsp;{value && HEALTH_ADJECTIVE_CHOICES[value]}&nbsp;
        </div>
    </div>;
}

HealthPicker.propTypes = {
    value: PropTypes.any,
    smoking: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};

export default HealthPicker;
